import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimplePopover } from '@dev/ee-components';
import { ContactStatus } from '@dev/ee-api/ee-api-models';

import styled from 'styled-components';

import { useDashboardElementVisibility } from '@/services/hooks/useDashboardElementVisibility';
import Props from './ChangeStatusProps';

const DialogContainer = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    .MuiCheckbox-root {
        padding: 4px 9px;
    }
    .MuiInputBase-root {
        margin-bottom: 16px;
    }
`;

export const ChangeContactStatus = (props: Props): JSX.Element => {
    const { t } = useTranslation();
    const { audience: { isAudienceTransactionalContactStatusVisible } } = useDashboardElementVisibility();

    const allStatuses = [
        {
            value: ContactStatus.Transactional,
            label: t('transactional'),
        },
        {
            value: ContactStatus.Active,
            label: t('active'),
        },
        {
            value: ContactStatus.Inactive,
            label: t('inactive'),
        },
        {
            value: ContactStatus.Unsubscribed,
            label: t('unsubscribed'),
        },
        {
            value: ContactStatus.Abuse,
            label: t('complaint'),
        },
    ];

    const statuses = allStatuses.filter((status) => {
        if (status.value === ContactStatus.Transactional) {
            return isAudienceTransactionalContactStatusVisible;
        }
        return true;
    });

    return (
        <DialogContainer>
            <SimplePopover
                id="change-status"
                label={t('status')}
                fullWidth={true}
                onItemClick={(e, obj: { value: string; label: string }): void => {
                    props.newStatus(obj.value);
                }}
                options={statuses}
                type="input"
                defaultValue={props.params.value}
            />
        </DialogContainer>
    );
};
